<div class="container">
    <!-- <app-nav-bar></app-nav-bar> -->
    <router-outlet></router-outlet>
</div>